module.exports = __webpack_public_path__ + "static/media/mobile-background-7.3799e6de.jpg";